import { SearchResult } from "../../../types"
import { formatDateTimeFromTimestamp } from "../../utils/datetime"

const DATE_FORMAT = "LLL d, yyyy"

// Short, type-specific facts shown under a search result so that identical
// titles (e.g. three "Michael Bracken" subscriptions) are distinguishable.
export const getSearchResultDetails = (data: SearchResult): string[] => {
  const details: string[] = []

  switch (data.type) {
    case "subscription":
    case "lead":
      if (data.email && data.email !== data.item) details.push(data.email)
      if (data.phone) details.push(data.phone)
      if (data.timestamp) {
        const created = formatDateTimeFromTimestamp(data.timestamp, DATE_FORMAT)
        if (created) details.push(`Created ${created}`)
      }
      break
    case "loan_officer":
      if (data.email) details.push(data.email)
      if (data.nmls) details.push(`NMLS ${data.nmls}`)
      break
    case "brand":
      if (data.url) details.push(data.url)
      break
    default:
      break
  }

  if (data.id) details.push(`ID ${data.id}`)

  return details
}
